<template>
  <div class="evalua_filter-root">
    <div class="content-search">
      <div class="sel-group-wrap">
        <select class="select date" :value="searchData.class_level" @change="$emit('levelChange',$event.target.value)">
          <option value>全部级别</option>
          <option v-for="item in classTrainLevelList" :value="item.value" :key="item.value">{{item.key}}</option>
        </select>
        <select class="select date" :value="searchData.date" @change="$emit('dateChange',$event.target.value)">
          <option value>全部时间</option>
          <option v-for="item in dateSelList" :value="item.value" :key="item.value">{{item.key}}</option>
        </select>
        <select class="select statu" :value="searchData.status" @change="$emit('statusChange',$event.target.value)">
          <option value>全部状态</option>
          <option v-for="item in statuSelList" :value="item.value" :key="item.value">{{item.key}}</option>
        </select>
      </div>
      <div class="search">
        <div class="wrap">
          <input
            class="search-input"
            :value="searchData.keywords"
            @input="$emit('keywordsChange',$event.target.value)"
            placeholder="请输入搜索内容"
            type="text"
            @keyup.enter="$emit('search')"
          >
          <div v-show="searchData.keywords!==''" class="close" @click="hideIcon">
            <v-icon name="regular/times-circle" scale="1.2"></v-icon>
          </div>
        </div>
        <span class="search-btn" @click.stop="$emit('search')">搜索</span>
      </div>
    </div>
  </div>
</template>

<script>
import { date, evaStatus,classLevelList } from "@/assets/js/select";
import Icon from "vue-awesome/components/Icon";
import fiveMixins from '@/minix/fiveMixins';

export default {
  name: 'EvaluaClassFilter',
  mixins: [fiveMixins],
  props: {
    searchData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dateSelList: date,
      statuSelList: evaStatus,
      classLevelList: classLevelList,
    }
  },
  methods: {
    hideIcon() {
      this.$emit('hideIcon','')
    },
  },
  components: {
    "v-icon": Icon,
  }
}
</script>

<style lang="stylus">
@import '~@/assets/css/variable'

.evalua_filter-root 
  display block 
  .content-search
    display flex
    flex none
    justify-content space-between
    color $color_black
    font-size $font_size_base
    height 34px
    .sel-group-wrap
      display flex
      .select
        width 120px
        border 1px solid #999
        padding 0 10px
        outline 0
      .date
        margin-right 10px
    .search
      display flex
      height 34px
      .wrap
        height 100%
        position relative
        .search-input
          width 160px
          height 100%
          padding 0 15px
          outline 0
        .close
          position absolute
          right 5px
          top 8px
          color $color_info
          cursor pointer
      .search-btn
        width 65px
        display flex
        align-items center
        justify-content center
        line-height 1
        background-color $color_suc
        color $color_white
        cursor pointer
</style>
